export default __webpack_public_path__ + "static/media/design.5fcdab3b.svg";